export const SOCKET_PATH = '//'


// WEBPACK FOOTER //
// ./src/ws.js